import { useGuidedTips } from "../../context/GuidedTipsContext";

/**
 * Personal on/off control for guided tips (UX-GUIDED-TIPS-001). Available to
 * every role: it changes only this user's own display preference.
 */
export default function GuidedTipsSettings() {
  const tips = useGuidedTips();
  if (!tips) return null;

  return (
    <section aria-label="הגדרות טיפים מודרכים" className="rounded-lg border border-gray-200 bg-white p-4 mb-6">
      <h2 className="text-sm font-semibold text-gray-800 mb-1">טיפים מודרכים</h2>
      <p className="text-xs text-gray-600 mb-3">
        בועות הסבר קצרות שמופיעות במסכים חשובים. הן אינן חוסמות את העבודה, אפשר לסגור כל אחת,
        וההעדפה נשמרת בדפדפן הזה עבור המשתמש שלך.
      </p>
      <label className="inline-flex items-center gap-2 text-sm text-gray-800">
        <input
          type="checkbox"
          checked={tips.enabled}
          onChange={(e) => tips.setEnabled(e.target.checked)}
        />
        הצג טיפים מודרכים
      </label>
      <div className="mt-2">
        <button
          type="button"
          onClick={tips.reset}
          className="text-xs text-blue-600 hover:underline"
        >
          הצג שוב את כל הטיפים
        </button>
      </div>
    </section>
  );
}
